import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mail, MailOpen } from "lucide-react";
import { content } from "../../data/content";
import { Reveal } from "./Reveal";

const CARD_COLORS = ["bg-butter", "bg-blush", "bg-sky text-white", "bg-white"];

function Envelope({ item, index }) {
  const [open, setOpen] = useState(false);
  return (
    <motion.button
      data-testid={`envelope-${index}`}
      onClick={() => setOpen((o) => !o)}
      whileHover={{ y: -6 }}
      whileTap={{ scale: 0.97 }}
      className={`${CARD_COLORS[index % CARD_COLORS.length]} relative text-left rounded-2xl border-[3px] border-ink shadow-brutal-lg p-6 md:p-7 min-h-[190px] flex flex-col`}
      style={{ rotate: index % 2 === 0 ? "-1.5deg" : "1.5deg" }}
    >
      <span className="flex items-center gap-2 font-body font-extrabold text-sm uppercase tracking-wide opacity-70">
        {open ? <MailOpen className="w-5 h-5" /> : <Mail className="w-5 h-5" />}
        Ábreme cuando
      </span>
      <span className="font-heading font-black text-xl md:text-2xl mt-1 leading-tight">
        {item.when}
      </span>

      <div className="mt-3 flex-1 flex items-center">
        <AnimatePresence mode="wait">
          {open ? (
            <motion.p
              key="note"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              className="font-body font-semibold text-base md:text-lg leading-snug"
            >
              {item.note}
            </motion.p>
          ) : (
            <motion.span
              key="hint"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="font-accent text-2xl md:text-3xl opacity-70"
            >
              toca para abrir
            </motion.span>
          )}
        </AnimatePresence>
      </div>
    </motion.button>
  );
}

export function OpenWhen() {
  return (
    <section
      data-testid="openwhen-section"
      className="relative w-full bg-cream px-5 md:px-10 py-24 md:py-32"
    >
      <div className="max-w-5xl mx-auto">
        <Reveal className="text-center mb-14 md:mb-20">
          <p className="font-accent text-3xl md:text-5xl text-rose -rotate-2 mb-1">
            {content.openWhen.kicker}
          </p>
          <h2 className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-ink">
            {content.openWhen.title}
          </h2>
          <p className="font-body font-semibold text-base md:text-xl text-ink/70 mt-3">
            {content.openWhen.subtitle}
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {content.openWhen.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <Envelope item={item} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
